import { createContext, useContext, type ReactNode } from 'react';
import type { PaymentMiddlewareClient } from '../infrastructure/paymentMiddlewareClient';

const PaymentMiddlewareClientContext = createContext<PaymentMiddlewareClient | null>(null);

export const PaymentMiddlewareClientProvider = ({
  client,
  children,
}: {
  client: PaymentMiddlewareClient | null;
  children: ReactNode;
}) => (
  <PaymentMiddlewareClientContext.Provider value={client}>
    {children}
  </PaymentMiddlewareClientContext.Provider>
);

export const usePaymentMiddlewareClient = (): PaymentMiddlewareClient | null =>
  useContext(PaymentMiddlewareClientContext);
